import { MoreVerticalIcon, Trash2Icon, Undo2Icon, XIcon } from 'lucide-react'

import { Button, DropdownMenu, IconButton, useBreakpoint } from 'slab'
import {
  usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdCancel,
} from 'utils/web_api'
import { useWindowLocation } from 'utils/windowLocation'

import { useOnboarding } from '../../OnboardingContext'
import { type Step } from '../../types'

export function QLEActionMenu ({
  navigateToSpecificStep,
}: {
  navigateToSpecificStep?: (step: Step) => void;
}) {
  const { breakpointIsAtLeast } = useBreakpoint()
  const isMobile = !breakpointIsAtLeast('xs')
  const { assign } = useWindowLocation()
  const { enrollmentEventId } = useOnboarding()

  const { mutate: cancelEnrollmentEvent } =
    usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdCancel({
      mutation: {
        onSuccess: () => {
          assign('/')
        },
      },
    })

  const handleNevermind = () => {
    if (enrollmentEventId) {
      window.segment?.track('[EE] QLE cancelled', {
        enrollment_event_id: enrollmentEventId,
        source: 'qle_onboarding',
      })
      cancelEnrollmentEvent({ enrollmentEventId })
    }
  }

  const trigger = isMobile
    ? (
      <Button
        variant='tertiary'
        size='large'
        width='full'
      >
        Change Request Options
      </Button>
      )
    : (
      <IconButton
        label='More options'
        icon={MoreVerticalIcon}
        size='large'
        variant='secondary'
      />
      )

  return (
    <DropdownMenu trigger={trigger}>
      <DropdownMenu.Section>
        <DropdownMenu.Item
          onSelect={() => assign('/')}
          leftIcon={Undo2Icon}
        >
          Save and return home
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onSelect={handleNevermind}
          leftIcon={Trash2Icon}
        >
          Cancel plan changes
        </DropdownMenu.Item>
      </DropdownMenu.Section>
      <DropdownMenu.Section>
        <DropdownMenu.Item
          onSelect={
            navigateToSpecificStep
              ? () => navigateToSpecificStep('opted_out')
              : undefined
          }
          leftIcon={XIcon}
          type='destructive'
        >
          Decline coverage
        </DropdownMenu.Item>
      </DropdownMenu.Section>
    </DropdownMenu>
  )
}
